// Notification utility functions

export const requestNotificationPermission = async () => {
  if (!('Notification' in window)) {
    console.log('This browser does not support notifications');
    return false;
  }

  if (Notification.permission === 'granted') {
    return true;
  }

  if (Notification.permission !== 'denied') {
    const permission = await Notification.requestPermission();
    return permission === 'granted';
  }

  return false;
};

export const showNotification = (title, options = {}) => {
  if (!('Notification' in window)) {
    console.log('This browser does not support notifications');
    return;
  }

  if (Notification.permission === 'granted') {
    const notificationOptions = {
      body: options.body || '',
      icon: options.icon || '/images/logo.webp',
      badge: options.badge || '/images/logo.webp',
      tag: options.tag || 'notification',
      requireInteraction: options.requireInteraction || false,
      vibrate: [200, 100, 200],
      ...options
    };

    const notification = new Notification(title, notificationOptions);

    // Handle notification click
    notification.onclick = (event) => {
      event.preventDefault();
      window.focus();
      if (options.onClick) {
        options.onClick();
      }
    };

    // Auto close after 5 seconds
    setTimeout(() => {
      notification.close();
    }, 5000);

    return notification;
  } else if (Notification.permission !== 'denied') {
    // Request permission if not yet requested
    requestNotificationPermission().then((granted) => {
      if (granted) {
        showNotification(title, options);
      }
    });
  }
};
